import React from "react";
import { TickSquare, CloseSquare } from "iconsax-react";
import CommonTable from "../../../Components/CommonTable";

const AllRequests = ({ data, nextPageUrl, prevPageUrl, onPageChange, totalCount, page }) => {

  return (
    <>
      <div className="flex flex-col gap-4 md:hidden">
        {data?.results?.map((item) => (
          <div
            key={item.request_id}
            className="w-full border border-gray-200 rounded-lg bg-white p-4 flex flex-col gap-3"
          >
            <div>
              <p className="text-xs text-gray-500">Request ID</p>
              <p className="text-sm font-medium text-gray-800">
                {item.request_id}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-y-3 gap-x-6">
              <div>
                <p className="text-xs text-gray-500">Name</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.employee_name}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Department</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.department}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Leave Dates</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.dates}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Type</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.category}
                </p>
              </div>

              {/* <div> */}
                {/* <p className="text-xs text-gray-500">Reason</p> */}
                {/* <p className="text-sm font-medium text-gray-800 truncate"> */}
                  {/* {item.reason} */}
                {/* </p> */}
              {/* </div> */}

              <div>
                <p className="text-xs text-gray-500">Approved By</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.approved_by || "— — — —"}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="hidden md:block">
        <CommonTable
          data={data?.results || []}
          rowKey="request_id"
          searchable={false}
          pagination={true}
          initialPageSize={10}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          onPageChange={onPageChange}
          totalCount={totalCount}
          page={page}
          columns={[
            { key: "request_id", label: "Request Id", sortable: true },
            // { key: "employee_name", label: "Name", sortable: true },
            { key: "department", label: "Department" },
            { key: "dates", label: "Leave Dates" },
            { key: "category", label: "Category" },
            // { key: "reason", label: "Reason", render: (v) => <div className="max-w-xs truncate">{v}</div> },
            { key: "approved_by", label: "Approved By" },
            { key: "status", label: "Status", sortable: true },
          ]}
          rowActions={(row) =>
            row.actions ? (
              <div className="flex items-center justify-center gap-2">
                <TickSquare size="20" color="#166534" variant="Bold" />
                <CloseSquare size="20" color="#ef4444" variant="Bold" />
              </div>
            ) : (
              <span className="text-gray-500 font-medium">{row.status}</span>
            )
          }
        />
      </div>
    </>
  );
};

export default AllRequests;
